import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LogService, FilteredLogSubscriberService, LogMessage, LogLevel } from './log.service';
import { ConsoleLogSubscriberService } from './console-log-subscriber.service';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class HttpLogSubscriberService extends FilteredLogSubscriberService {

  readonly errorUrl = `${this.environment.baseUrl}/api/error`;
  readonly HTTP_ERROR_MSG = 'HttpLogSubscriberService - Could not stream message to the server;';

  constructor(logService: LogService,
              private http: HttpClient,
              private consoleLogSubscriber: ConsoleLogSubscriberService,
              private environment: EnvironmentConfiguration) {
    super(logService);
  }

  public log(logMessage: LogMessage) {
    let bodyString = JSON.stringify(logMessage); // Stringify payload
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    // TODO: Add meta information to the error so it can be identified on
    // the server and correlated to other errors.
    // headers.append('SessionId', user.sessionId)
    // headers.append('UserId', user.userId)
    let options = { headers: headers }; // Create a request option

    const post = this.http.post(this.errorUrl, bodyString, options);
    post.subscribe(undefined, error => {
      this.consoleLogSubscriber.log(
        new LogMessage(LogLevel.ERROR, this.HTTP_ERROR_MSG + error)
      );
      this.consoleLogSubscriber.log(logMessage);
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/log/http-log-subscriber.service.ts